import React, { useState } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';
import { withRouter } from 'react-router-dom';
import TMCard from '../../../components/TMCard/TMCard';
import { getLogo } from '../../../assets/helper';
import { Button, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
const { REACT_APP_STAGE } = process.env

const WellnessCenterVerification = props => {
  const history = useHistory()
  const [verificationStatus, setVerificationStatus] = useState(0);
  // const hasGrade = typeof props.participantInfo.grade === 'string';
  const isAdult = props.participantInfo.appliedTo === 'adult';
  // const gradeData = ["K", ...Array.from(Array(13).keys()).slice(1)];
  const participantDobString = (new Date(props.participantInfo.birthDate * 1000)).toLocaleDateString("fr-CA", { timeZone: "UTC" })

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target); // Constructing the FormData object
    console.log(`verifying`)
    const dobInputValue = formData.get("dobInput");
    // Convert user input (YYYY-MM-DD) to epoch (seconds)
    const dobInputEpoch = dobInputValue ? Math.floor(new Date(dobInputValue + 'T00:00:00Z').getTime() / 1000) : null;
    if (
      // disabled grade verification
      // (isAdult || !hasGrade || formData.get("gradeSelect") === props.participantInfo.grade) &&
      Math.abs(dobInputEpoch - props.participantInfo.birthDate) <= 86400 // allow one day difference
    ) {
      console.log(`verification ok`)
      setVerificationStatus(1)
      setTimeout( () => { history.push(`/wellness-center/report/${isAdult ? 'adult' : 'parent'}/${props.participantId}`)}, 1500)
    } else {
      console.log('verification error')
      if (REACT_APP_STAGE === "dev") {
        console.log("participant: ", participantDobString)
        console.log("submitted:" ,  formData.get("dobInput") )
      }
      setVerificationStatus(-1) // error
    }
  }
  return (
    <div className="page-container-survey-access wellness-center mb-3">
      <TMCard
        className="tm-card-stepper"
        header={[
          <div className="text-center mb-4">
            <img className="w-75 " src={getLogo()} alt="Logo" />
          </div>,
        ]}
      >
        <Container fluid>
          <Row>
            <h1>Assessment Results Access</h1>
            <p>For your security, please complete the information below to retrieve the results for: <strong>{props.participantInfo.lastName.charAt(0) + "., " + props.participantInfo.firstName.charAt(0) + "."}</strong></p>
            {verificationStatus === -1 ?
              <><p>We could not verify your information. Please contact support.</p></>
              : <Form onSubmit={handleSubmit}>
                {/* {(hasGrade && !isAdult) &&
                  <FormGroup>
                    <Label for="gradeSelect">
                      Participant Grade:
                    </Label>
                    <Input
                      id="gradeSelect"
                      name="gradeSelect"
                      type="select"
                    >
                      {gradeData.map(grade => <option key={`grade_${grade}`}>{grade}</option>)}
                    </Input>
                  </FormGroup>} */}
                <FormGroup>
                  <Label for="dobInput">
                    Participant Date of Birth:
                  </Label>
                  <Input
                    id="dobInput"
                    name="dobInput"
                    placeholder="Select date"
                    type="date"
                    defaultValue={'2017-01-01'}
                  />
                </FormGroup>
                <Button color='primary' disabled={verificationStatus !== 0}>
                  Submit information
                </Button>
                { verificationStatus === 1 && <p className='mt-3 text-success fw-bold'>Successfully verified information. You will be redirected soon. Please wait...</p>}
              </Form>
            }
          </Row>
        </Container>
      </TMCard>
    </div>
  );
};

const mapStatetoProps = state => {
  return state.wellnessCenterAuth;
};

const mapDispatchToProps = dispatch => {
  return {
    openModal: modalProps => dispatch(actions.openModal(modalProps)),
    // saveSurveyParticipantResponseData: (surveyDataToSend) => dispatch(saveSurveyParticipantResponseData(surveyDataToSend))
  };
};

export default withRouter(
  connect(
    mapStatetoProps,
    mapDispatchToProps,
  )(WellnessCenterVerification),
);
